export const colorOne = "#000000"; // black
export const colorTwo = "#1c816b"; // green
export const colorThree = "#B01D1D"; // Red
export const colorFour = "#828ff1"; // lavender
export const colorFive = "#efbf55"; // yellow
export const colorSix = "#9383b8"; // darker lavender
export const colorSeven = "#df8c55"; // orange
export const colorEight = "#95c9d5"; // mint?
export const colorNine = "#2e3d49"; //charcoal?
export const colorTen = "#e4e4e4";

export const colorOneLight = `${colorOne}10`; // black
export const colorTwoLight = `${colorTwo}20`; // green
export const colorThreeLight = `${colorThree}99`; // Slightly lighter red
export const colorThreeVeryLight = `${colorThree}10`; // Very light red
export const colorFourLight = "#7A9EFA10"; // light lavendar
export const colorFiveLight = `${colorFive}20`; // lightest yellow
export const colorSixLight = `${colorSix}20`;
export const colorSevenLight = `${colorSeven}20`; // orange
export const colorEightLight = "#ecf2f5"; // light mint?

export const secondaryColorFive = "#ffe3a8"; // lighter yellow
export const secondaryColorSix = "#403658"; // darker darker lavender
export const secondaryColorSeven = "#FFBB8E";
export const secondaryColorEight = "#95c9d5"; // darker mint?

export const colorTwoBright = "#1ce180"; //new bright green
export const colorTwoDark = "#2b8b49"; //new dark green

export const altGrayTextColor = "#2c2c2c";
export const hoverLinkBlue = "#0091ff";
export const lightBorderGray = "#e4e4e4";
export const activePsychSort = "#2e3d49";
export const activeSortDirection = "#1ce180";
export const inactiveSortDirection = "#b4b4b4";
export const anotherLightGray = "#f5f5f5";

export const CustomerBreakoutColors: {
  P: string;
  S: string;
  T: string;
  N: string;
} = {
    P: "#fd504d",
    S: "#5e73ff",
    T: "#c4c4c4",
    N: "#c4c4c4",
};
